import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class Erdgasverbrauch extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    jahr: number | null = null;
    kanton_id: number | null = null;
    gemeinde_id: number | null = null;
    verbrauch: number | null = null;
    energieversorgungsunternehmen: string | null = null;
    ort: string | null = null;

    // view fields
    kanton_kuerzel: string | null = null;
    kanton: string | null = null;
    gemeinde: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'Erdgasverbrauch';
    }
}

export async function createNewErdgasverbrauch(): Promise<Erdgasverbrauch> {
    const erdgasverbrauch = createModel(Erdgasverbrauch, {});

    await erdgasverbrauch.save();
    return erdgasverbrauch;
}

export class ErdgasverbrauchCollection extends BaseCollection<Erdgasverbrauch> {
    protected modelCls = Erdgasverbrauch;

    public getModelClassName(): string {
        return 'Erdgasverbrauch';
    }
}
